<template>
  <div class="textInputAreaWrapper" v-on:click.native="scrollToBottom">
    <textarea v-model="textInput" v-bind:class="{textInputArea: true, placeholder: showPlaceholder}" v-on:keyup="onKeyUp" v-on:click="onClick">
    </textarea>
  </div>
</template>

<script>



  import LargePrimaryButton from "@/components/buttons/LargePrimaryButton";

  export default {
    name: 'textInputArea',
    components: {
      LargePrimaryButton,
    },
    props: ['text', 'defaultText', 'placeholder', 'buttonText', 'newLineNumbers'],
    data() {
      return {
        clicked:  false,
      }
    },

    computed: {
      textInput: {
        get: function(){
          if (this.showPlaceholder) return this.placeholder;
          return this.text;
        },
        set: function(newValue){
          if (typeof newValue !== 'string') return;
          this.$emit('update:text', newValue)
        }
      },

      showPlaceholder: function () {
        return !this.clicked && this.placeholder && this.text === this.defaultText;
      },

      canSubmit: function() {
        let input = this.textInput.replace(/\n/g, '').trim();
        return input !== '' && input !== '1.' && input !== '1';
      }
    },
    methods: {
      submit: function () {
        this.$emit('submit', this.textInput);
      },

      onKeyUp: function(e) {
        if (this.newLineNumbers && e.key === 'Enter') {
          let lines = this.textInput.split('\n').length;
          this.textInput = this.textInput += `${lines}. `
        }
        this.inputStarted(e);
      },

      onClick: function (e) {
        this.clicked = true;
      },

      inputStarted: function(e) {
        console.log(`internal event`);
        this.$emit('inputStarted');
        this.scrollToBottom();
      },

      scrollToBottom() {
        window.scrollTo(0,document.body.scrollHeight);
      },

      update: function(e) {
        this.updateText(e);
      },

      updateText: function (e) {
        this.textInput = this.getArrayFromLiElements(e.target.getElementsByTagName('li'));
      },

    },

    created() {

    }
  }
</script>

<style lang="scss">
@import "src/assets/scss/variables";

.textInputAreaWrapper {
  background: #fff;
  border-top: 1px solid #AEAEB2;
  border-bottom: 1px solid #AEAEB2;
}

.textInputArea {
  padding: $primaryPadding;
  outline: none;
  overflow: scroll;
  font-size: $secondaryTextFontSize;
  width: 100%;
  height: 100%;

  &.placeholder {
    color: rgba(60, 60, 67, 0.6);
  }
}

.textInputArea ol {
  outline: none;
  -webkit-user-select: text;
  user-select: text;
  -webkit-user-modify:read-write;


}


input,
textarea,
[contenteditable] {
  -webkit-user-select: text;
  user-select: text;
  -webkit-user-modify:read-write;

}

</style>
